let ENDPOINT

if (process.env.NODE_ENV === 'development') {
    ENDPOINT = 'http://127.0.0.1:8000/'
} else if (process.env.NODE_ENV === 'staging') {
    ENDPOINT = 'https://dev-admin.hayden5.com/'
} else {
    ENDPOINT = 'https://admin.hayden5.com/'
}

export { ENDPOINT }

const PREFIX = `${ ENDPOINT }api/`

export const SIGN_UP_URL = `${ PREFIX }account/sign-up`
export const SIGN_IN_URL = `${ PREFIX }account/sign-in`
export const RESEND_ACTIVATION_LINK_URL = `${ PREFIX }account/resend-activation-link/:uuid`
export const ACTIVATE_URL = `${ PREFIX }account/activate/:uuid/:token`
export const IMPERSONATE_URL = `${ PREFIX }account/impersonate`
export const AUTHENTICATE_URL = `${ PREFIX }account/authenticate`
export const FORGOT_PASSWORD_URL = `${ PREFIX }account/reset-password`
export const VALIDATE_RESET_TOKEN_URL = `${ PREFIX }account/reset-password-validate/:uuid/:token`
export const SET_PASSWORD_URL = `${ PREFIX }account/set-password/:uuid/:token`

export const LOAD_CREW_TYPES_URL = `${ PREFIX }crew/type/?optionList`
export const LOAD_INSURANCE_TYPES_URL = `${ PREFIX }crew/insurance/`
export const LOAD_VEHICLE_TYPES_URL = `${ PREFIX }crew/vehicle/type/`
export const LOAD_VEHICLE_MAKES_URL = `${ PREFIX }crew/vehicle/make/`
export const LOAD_INDUSTRY_TYPES_URL = `${ PREFIX }crew/industry/`
export const LOAD_LANGUAGES_URL = `${ PREFIX }crew/language/`

export const LOAD_COUNTRIES_URL = `${ PREFIX }location/country/?optionList`
export const LOAD_REGIONS_URL = `${ PREFIX }location/region/?optionList`
export const LOAD_CITIES_URL = `${ PREFIX }location/city/?optionList`

export const LOAD_ICA_URL = `${ PREFIX }contract/:uuid`
export const SUBMIT_ICA_URL = `${ PREFIX }contract/`

// export const LOAD_PAYMENT_DETAILS_URL = `${ PREFIX }payroll/stripe-account/`
// export const SUBMIT_PAYMENT_DETAILS_URL = `${ PREFIX }payroll/stripe-account/`

export const LOAD_PERSONAL_URL = `${ PREFIX }crew/:crew_uuid`
export const PATCH_PERSONAL_URL = `${ PREFIX }crew/update/:crew_uuid`
export const SUBMIT_PERSONAL_URL = `${ PREFIX }crew/update/:crew_uuid`

export const ADD_ADDITIONAL_CITY_URL = `${ PREFIX }crew/additional-city/:crew_uuid/add/`
export const UPDATE_ADDITIONAL_CITY_URL = `${ PREFIX }crew/additional-city/:crew_uuid/update/:item_uuid`
export const DELETE_ADDITIONAL_CITY_URL = `${ PREFIX }crew/additional-city/:crew_uuid/delete/:item_uuid`

export const LOAD_EXPERIENCE_URL = `${ PREFIX }crew/experience/:crew_uuid`
export const PATCH_EXPERIENCE_URL = `${ PREFIX }crew/experience/update/:crew_uuid`
export const SUBMIT_EXPERIENCE_URL = `${ PREFIX }crew/experience/update/:crew_uuid`

export const UPLOAD_PHOTO_URL = `${ PREFIX }crew/upload-photo/`
export const UPLOAD_RESUME_URL = `${ PREFIX }crew/experience/upload-resume/`

export const UPDATE_CREW_POSITIONS_URL = `${ PREFIX }crew/update-crew-type/:uuid`

export const LOAD_DOCS_URL = `${ PREFIX }document/list/`
export const LOAD_SINGLE_DOC_URL = `${ PREFIX }document/retrieve/:slug`

// gear section

// loading crew's gear data
export const LOAD_GEAR_URL = `${ PREFIX }crew/gear/:crew_uuid`

// patching/posting crew's gear data
export const PATCH_GEAR_URL = `${ PREFIX }crew/gear/update/:crew_uuid?crew_type=:crew_type`
export const POST_GEAR_URL = `${ PREFIX }crew/gear/update/:crew_uuid`

// committing a full crew type form
export const COMMIT_GEAR_URL = `${ PREFIX }crew/gear/commit/:crew_uuid/:type`

// loading data to fill video camera options
export const LOAD_VIDEO_CAMERA_MAKES_URL = `${ PREFIX }gear/camera/make/?type=video&optionList`
export const LOAD_VIDEO_CAMERA_MODELS_URL = `${ PREFIX }gear/camera/model/?type=video&optionList`

// submission of video camera data
export const ADD_VIDEO_CAMERA_URL = `${ PREFIX }crew/gear/camera/:crew_uuid/add/`
export const UPDATE_VIDEO_CAMERA_URL = `${ PREFIX }crew/gear/camera/:crew_uuid/update/:item_uuid`
export const DELETE_VIDEO_CAMERA_URL = `${ PREFIX }crew/gear/camera/:crew_uuid/delete/:item_uuid`

// loading data to fill still camera options
export const LOAD_STILL_CAMERA_MAKES_URL = `${ PREFIX }gear/camera/make/?type=still&optionList`
export const LOAD_STILL_CAMERA_MODELS_URL = `${ PREFIX }gear/camera/model/?type=still&optionList`

// submission of still camera data
export const ADD_STILL_CAMERA_URL = `${ PREFIX }crew/gear/camera/:crew_uuid/add/`
export const UPDATE_STILL_CAMERA_URL = `${ PREFIX }crew/gear/camera/:crew_uuid/update/:item_uuid`
export const DELETE_STILL_CAMERA_URL = `${ PREFIX }crew/gear/camera/:crew_uuid/delete/:item_uuid`

// loading data to fill lens options
export const LOAD_LENS_MAKES_URL = `${ PREFIX }gear/lens/make/?optionList`
export const LOAD_LENS_MODELS_URL = `${ PREFIX }gear/lens/model/?optionList`

// submission of lens data
export const ADD_LENS_URL = `${ PREFIX }crew/gear/lens/:crew_uuid/add/`
export const ADD_LENSES_URL = `${ PREFIX }crew/gear/lens/:crew_uuid/add/`
export const UPDATE_LENS_URL = `${ PREFIX }crew/gear/lens/:crew_uuid/update/:item_uuid`
export const DELETE_LENS_URL = `${ PREFIX }crew/gear/lens/:crew_uuid/delete/:item_uuid`

// loading data to fill support equipment options
export const LOAD_SUPPORT_EQUIPMENT_TYPES_URL = `${ PREFIX }gear/support-equipment/type/?optionList`

// submission of support equipment data
export const ADD_SUPPORT_EQUIPMENT_URL = `${ PREFIX }crew/gear/support-equipment/:crew_uuid/add/`
export const UPDATE_SUPPORT_EQUIPMENT_URL = `${ PREFIX }crew/gear/support-equipment/:crew_uuid/update/:item_uuid`
export const DELETE_SUPPORT_EQUIPMENT_URL = `${ PREFIX }crew/gear/support-equipment/:crew_uuid/delete/:item_uuid`

// loading data to fill microphone type/make options
export const LOAD_MICROPHONE_TYPES_URL = `${ PREFIX }gear/microphone/type/?optionList`
export const LOAD_MICROPHONE_MAKES_URL = `${ PREFIX }gear/microphone/make/?optionList`

// submission of microphone
export const ADD_MICROPHONE_URL = `${ PREFIX }crew/gear/microphone/:crew_uuid/add/`
export const UPDATE_MICROPHONE_URL = `${ PREFIX }crew/gear/microphone/:crew_uuid/update/:item_uuid`
export const DELETE_MICROPHONE_URL = `${ PREFIX }crew/gear/microphone/:crew_uuid/delete/:item_uuid`

// loading data to fill audio recorder make options
export const LOAD_AUDIO_RECORDER_TYPES_URL = `${ PREFIX }gear/recorder/type/?type=audio&optionList`
export const LOAD_AUDIO_RECORDER_MAKES_URL = `${ PREFIX }gear/recorder/make/?type=audio&optionList`

// submission of audio recorder/mixer
export const ADD_AUDIO_RECORDER_URL = `${ PREFIX }crew/gear/recorder/audio/:crew_uuid/add/`
export const UPDATE_AUDIO_RECORDER_URL = `${ PREFIX }crew/gear/recorder/audio/:crew_uuid/update/:item_uuid`
export const DELETE_AUDIO_RECORDER_URL = `${ PREFIX }crew/gear/recorder/audio/:crew_uuid/delete/:item_uuid`

// loading data to fill video recorder make options
export const LOAD_VIDEO_RECORDER_TYPES_URL = `${ PREFIX }gear/recorder/type/?type=video&optionList`
export const LOAD_VIDEO_RECORDER_MAKES_URL = `${ PREFIX }gear/recorder/make/?type=video&optionList`

// submission of video recorder
export const ADD_VIDEO_RECORDER_URL = `${ PREFIX }crew/gear/recorder/video/:crew_uuid/add/`
export const UPDATE_VIDEO_RECORDER_URL = `${ PREFIX }crew/gear/recorder/video/:crew_uuid/update/:item_uuid`
export const DELETE_VIDEO_RECORDER_URL = `${ PREFIX }crew/gear/recorder/video/:crew_uuid/delete/:item_uuid`

// loading data to fill wireless video system type and make options
export const LOAD_WIRELESS_VIDEO_SYSTEM_TYPES_URL = `${ PREFIX }gear/wireless-system/type/?type=video&optionList`
export const LOAD_WIRELESS_VIDEO_SYSTEM_MAKES_URL = `${ PREFIX }gear/wireless-system/make/?type=video&optionList`

// submission of wireless video system
export const ADD_WIRELESS_VIDEO_SYSTEM_URL = `${ PREFIX }crew/gear/wireless-system/:crew_uuid/add/`
export const UPDATE_WIRELESS_VIDEO_SYSTEM_URL = `${ PREFIX }crew/gear/wireless-system/:crew_uuid/update/:item_uuid`
export const DELETE_WIRELESS_VIDEO_SYSTEM_URL = `${ PREFIX }crew/gear/wireless-system/:crew_uuid/delete/:item_uuid`

// loading data to fill wireless audio system type and make options
export const LOAD_WIRELESS_AUDIO_SYSTEM_TYPES_URL = `${ PREFIX }gear/wireless-system/type/?type=audio&optionList`
export const LOAD_WIRELESS_AUDIO_SYSTEM_MAKES_URL = `${ PREFIX }gear/wireless-system/make/?type=audio&optionList`

// submission of wireless audio system
export const ADD_WIRELESS_AUDIO_SYSTEM_URL = `${ PREFIX }crew/gear/wireless-system/:crew_uuid/add/`
export const UPDATE_WIRELESS_AUDIO_SYSTEM_URL = `${ PREFIX }crew/gear/wireless-system/:crew_uuid/update/:item_uuid`
export const DELETE_WIRELESS_AUDIO_SYSTEM_URL = `${ PREFIX }crew/gear/wireless-system/:crew_uuid/delete/:item_uuid`

// loading data to fill video lighting kit type/make options
export const LOAD_VIDEO_LIGHTING_KIT_TYPES_URL = `${ PREFIX }gear/lighting-kit/type/?type=video&optionList`
export const LOAD_VIDEO_LIGHTING_KIT_MAKES_URL = `${ PREFIX }gear/lighting-kit/make/?type=video&optionList`

// submission of video lighting kit
export const ADD_VIDEO_LIGHTING_KIT_URL = `${ PREFIX }crew/gear/lighting-kit/:crew_uuid/add/`
export const UPDATE_VIDEO_LIGHTING_KIT_URL = `${ PREFIX }crew/gear/lighting-kit/:crew_uuid/update/:item_uuid`
export const DELETE_VIDEO_LIGHTING_KIT_URL = `${ PREFIX }crew/gear/lighting-kit/:crew_uuid/delete/:item_uuid`

// loading data to fill still lighting kit type/make options
export const LOAD_STILL_LIGHTING_KIT_TYPES_URL = `${ PREFIX }gear/lighting-kit/type/?type=still&optionList`
export const LOAD_STILL_LIGHTING_KIT_MAKES_URL = `${ PREFIX }gear/lighting-kit/make/?type=still&optionList`

// submission of still lighting kit
export const ADD_STILL_LIGHTING_KIT_URL = `${ PREFIX }crew/gear/lighting-kit/:crew_uuid/add/`
export const UPDATE_STILL_LIGHTING_KIT_URL = `${ PREFIX }crew/gear/lighting-kit/:crew_uuid/update/:item_uuid`
export const DELETE_STILL_LIGHTING_KIT_URL = `${ PREFIX }crew/gear/lighting-kit/:crew_uuid/delete/:item_uuid`

// loading data to fill monitor type/make options
export const LOAD_MONITOR_TYPES_URL = `${ PREFIX }gear/monitor/type/?optionList`
export const LOAD_MONITOR_MAKES_URL = `${ PREFIX }gear/monitor/make/?optionList`

// submission of monitor
export const ADD_MONITOR_URL = `${ PREFIX }crew/gear/monitor/:crew_uuid/add/`
export const UPDATE_MONITOR_URL = `${ PREFIX }crew/gear/monitor/:crew_uuid/update/:item_uuid`
export const DELETE_MONITOR_URL = `${ PREFIX }crew/gear/monitor/:crew_uuid/delete/:item_uuid`

// submission of computer
export const ADD_COMPUTER_URL = `${ PREFIX }crew/gear/computer/:crew_uuid/add/`
export const UPDATE_COMPUTER_URL = `${ PREFIX }crew/gear/computer/:crew_uuid/update/:item_uuid`
export const DELETE_COMPUTER_URL = `${ PREFIX }crew/gear/computer/:crew_uuid/delete/:item_uuid`

// submission of equipment list
export const UPLOAD_EQUIPMENT_LIST_URL = `${ PREFIX }crew/gear/equipment-list/`

// submission of additional gear
export const ADD_ADDITIONAL_GEAR_URL = `${ PREFIX }crew/gear/additional-gear/:crew_uuid/add/`
export const UPDATE_ADDITIONAL_GEAR_URL = `${ PREFIX }crew/gear/additional-gear/:crew_uuid/update/:item_uuid`
export const DELETE_ADDITIONAL_GEAR_URL = `${ PREFIX }crew/gear/additional-gear/:crew_uuid/delete/:item_uuid`

// submission of drone
export const ADD_DRONE_URL = `${ PREFIX }crew/gear/drone/:crew_uuid/add/`
export const UPDATE_DRONE_URL = `${ PREFIX }crew/gear/drone/:crew_uuid/update/:item_uuid`
export const DELETE_DRONE_URL = `${ PREFIX }crew/gear/drone/:crew_uuid/delete/:item_uuid`

// submission of DIT software package
export const ADD_DIT_SOFTWARE_URL = `${ PREFIX }crew/gear/dit-software/:crew_uuid/add/`
export const UPDATE_DIT_SOFTWARE_URL = `${ PREFIX }crew/gear/dit-software/:crew_uuid/update/:item_uuid`
export const DELETE_DIT_SOFTWARE_URL = `${ PREFIX }crew/gear/dit-software/:crew_uuid/delete/:item_uuid`

// loading data to fill transportation questions
export const LOAD_TRANSPORTATION_OPTIONS_URL = `${ PREFIX }gear/transportation/options/`

// loading data to fill software questions
export const LOAD_SOFTWARE_OPTIONS_URL = `${ PREFIX }gear/software/`

// submission of additional software
export const ADD_ADDITIONAL_SOFTWARE_URL = `${ PREFIX }crew/gear/additional-software/:crew_uuid/add/`
export const UPDATE_ADDITIONAL_SOFTWARE_URL = `${ PREFIX }crew/gear/additional-software/:crew_uuid/update/:item_uuid`
export const DELETE_ADDITIONAL_SOFTWARE_URL = `${ PREFIX }crew/gear/additional-software/:crew_uuid/delete/:item_uuid`

// submission of additional hardware
export const ADD_ADDITIONAL_HARDWARE_URL = `${ PREFIX }crew/gear/additional-hardware/:crew_uuid/add/`
export const UPDATE_ADDITIONAL_HARDWARE_URL = `${ PREFIX }crew/gear/additional-hardware/:crew_uuid/update/:item_uuid`
export const DELETE_ADDITIONAL_HARDWARE_URL = `${ PREFIX }crew/gear/additional-hardware/:crew_uuid/delete/:item_uuid`

// jobs section
export const LOAD_JOBS_URL = `${ PREFIX }callsheet/list/jobs/:crew_uuid`
export const LOAD_JOB_URL = `${ PREFIX }callsheet/job/:crew_uuid/:job_uuid`

// submission of invoice
export const SUBMIT_INVOICE_URL = `${ PREFIX }invoice/add/`
export const RECEIPT_UPLOAD_URL = `${ PREFIX }invoice/receipt/upload/`

// request overtime
export const REQUEST_OVERTIME_URL = `${ PREFIX }callsheet/job/:crew_uuid/:job_uuid/request-overtime`



// WEBPACK FOOTER //
// ./app/constants/APIEndpoints.js